import { render, staticRenderFns } from "./PropertyDrawer.vue?vue&type=template&id=2c1dde88&scoped=true&"
import script from "./PropertyDrawer.vue?vue&type=script&lang=js&"
export * from "./PropertyDrawer.vue?vue&type=script&lang=js&"
import style0 from "./PropertyDrawer.vue?vue&type=style&index=0&id=2c1dde88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1dde88",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VIcon,VTooltip})
